var map = {
	"./01.png": "./src/public/asset/images/hero-2/01.png",
	"./02.png": "./src/public/asset/images/hero-2/02.png",
	"./03.png": "./src/public/asset/images/hero-2/03.png",
	"./04.png": "./src/public/asset/images/hero-2/04.png",
	"./05.png": "./src/public/asset/images/hero-2/05.png",
	"./06.png": "./src/public/asset/images/hero-2/06.png",
	"./07.png": "./src/public/asset/images/hero-2/07.png",
	"./08.png": "./src/public/asset/images/hero-2/08.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/public/asset/images/hero-2 sync recursive ^\\.\\/.*$";